export interface BaseAction {
  type: string;
  payload: any;
  [extraProps: string]: any;
}

function AppBaseAction (type: string, payload: any): BaseAction {
  let action: BaseAction = {type: type, payload: payload};
  return action;
}

export default AppBaseAction;